import { useState } from "react";
import { addCustomer } from "../../api/customerApi";
import { useAuth } from "../../context/AuthContext";
export function useAddCustomer() {
  const [customer, setCustomer] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
  });

  const [noEmail, setNoEmail] = useState(false);
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCustomer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSave = async () => {
    setLoading(true);
    try {
      // Example API endpoint
      let newCustomer = {
        ...customer,
        ...(noEmail && {
          email:
            customer.firstName.trim() +
            "." +
            customer.lastName.trim() +
            "@localhost.com",
        }),
      };
      const response = await addCustomer(newCustomer, user.barberShop);
      if (response.data.isSuccess) {
        setMessage({ text: response.data.value, type: "success" });
        setShowMessage(true);
      } else {
        setMessage({
          text: response.data.errors.join("\n"),
          type: "danger",
        });
        setShowMessage(true);
      }
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
  };
  const onClear = () => {
    setCustomer({
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
    });
  };
  return {
    customer,
    handleChange,
    noEmail,
    setNoEmail,
    onSave,
    loading,
    onClear,
    message,
    showMessage,
    setShowMessage,
  };
}
